import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";

import { useDebounce } from "~/hooks/use-debounce";
import { useT } from "@repo/transifex";

import { BaseInput } from "..";

export const OrdersSearchInput = ({
  onSearch
}: {
  onSearch: (value: string) => void;
}) => {
  const debouncedSearch = useDebounce(onSearch);

  const t = useT();

  return (
    <BaseInput
      placeholder={t(
        "Search by Order ID, products, authenticated user and cashier name"
      )}
      suffix={<FontAwesomeIcon icon={faSearch} />}
      onChange={(e) => {
        debouncedSearch(e.target.value);
      }}
    />
  );
};
